export var ApplePayMerchantCapabilitiesObj = [
    "supports3DS",
    "supportsEMV",
    "supportsCredit",
    "supportsDebit",
];
/** @internal */
export var validateApplePayMerchantCapability = function (applePayMerchantCapability) {
    return ApplePayMerchantCapabilitiesObj.includes(applePayMerchantCapability);
};
